import { useMemo } from "react";
import { getMetadataFromRecord } from "utils/RecordUtils";

const useMetadataValue = (record, field, fieldType) => {
  const metadata = useMemo(() => {
    if (!record || !field || !fieldType) return null;

    return getMetadataFromRecord(record, field, fieldType);
  }, [record, field, fieldType]);

  return metadata;
};

export default useMetadataValue;
